import PropTypes from 'prop-types'
import React, { Component } from 'react'

import Link from 'design-system/Link'
import FacebookConnectButton from 'base/react/components/facebook_connect_button'

export default class FacebookSignInForm extends Component {
  static propTypes = {
    siteLocation: PropTypes.string.isRequired,
    onSuccess: PropTypes.func,
    onFailure: PropTypes.func,
    onClickLoginWithEmail: PropTypes.func,
  }

  renderFacebookButton() {
    return (
      <FacebookConnectButton
        showIcon
        onSuccess={this.props.onSuccess}
        onError={this.props.onFailure}
        siteLocation={this.props.siteLocation}
        className="login__social-button"
      >
        Log in with Facebook
      </FacebookConnectButton>
    )
  }

  render() {
    return (
      <div className="login__facebook-sign-in-form">
        <p className="social-sign-in-form__message">Log in with Facebook to continue.</p>
        {this.renderFacebookButton()}
        <div className="social-sign-in-form__link">
          <Link href="#" onClick={this.props.onClickLoginWithEmail}>
            Or log in with email instead.
          </Link>
          .
        </div>
      </div>
    )
  }
}
